import React from 'react';
import Bottlingline from "../../../assets/images/Bottlingline.png";
import Corker1 from "../../../assets/images/Corker1.png";
import Labelling from "../../../assets/images/Labelling.png";
import Corkers from "../../../assets/images/Corkers.png";
import SparklingBottling from "../../../assets/images/SparklingBottling.png"
import { useTranslation } from 'react-i18next';

function BotlingLabeling() {
  const { t } = useTranslation();
  const products = [
    {
      name: <h1>{t('Bottling line')}</h1>,
      description: <h2>{t('In the wine industry the finishing touches have an immense impact on the final product, which incorporates rinsing, filling and capping the bottles in order to receive our manufacture and have it ready for labeling. Our machinery delivers a fast, steady and effective solution for winemakers.')}</h2>,
      image: Bottlingline,
    },
    {
      name: <h1>{t('Corker')}</h1>,
      description: <h2>{t('A wine corker is a specialized tool that allows you to insert a cork into your bottle in a quick, easy, and safe manner. Corkers work by first compressing the cork, then inserting it into the bottle in a single motion.')}</h2>,
      image: Corker1,
    },
    {
      name: <h1>{t('Sparkling Bottling Equipment')}</h1>,
      description: <h2>{t('Sparkling wines hold a special position in the wine industry, therefore they also require to be handled in a unique manner. Our machinery will secure the process and achieve the needed results.')}</h2>,
      image: SparklingBottling, 
    },
    {
      name: <h1>{t('Labelling')}</h1>,
      description: <h2>{t('Our bottle labelling machines are considered the best in the industry, offering unparalleled reliability, speed, and efficiency. These top-quality machines can be used to apply pre-printed labels.')}</h2>,
      image: Labelling,
    },
    {
      name: <h1>{t('Wine Corks')}</h1>,
      description: <h2>{t('The most important part of bottling is the choice of cork, which also has to coincide with the type of wine you are producing. We offer a large variety of wine corks.')}</h2>,
      image: Corkers, 
    },
  ];

  return (
    <div className='main-infocontainer'>
      {products.map((product, index) => (
        <div className='item-container' key={index}>
          <img src={product.image} alt={product.name} />
          <div className='text-info'>
            {product.name}
            {product.description}
          </div>
        </div>
      ))}
    </div>
  );
}

export default BotlingLabeling;
